import { applyAllOf } from './applyAllOf'
import { buildInitialParams } from './buildInitialParams'
import { collectAllowedKeys } from './collectAllowedKeys'

/**
 * Resolves a schema's canonical_params: property values and defaults, the allOf rules,
 * the schema's allowed-key filter and the keyToConvert renames. Shared by the 3D and the
 * image payload builders, which differ only in where the values come from.
 *
 * @param {Object} schema - A MODEL_SOURCES or IMAGE_SOURCES entry
 * @param {(key: string) => *} getValue - Resolves the current value for a canonical key
 * @returns {Object} The canonical_params to send
 */
export const buildCanonicalParams = (schema, getValue) => {
  const inputSchema = schema.input_schema || {}
  const properties = inputSchema.properties || {}
  const topLevelRequired = inputSchema.required || []
  const allOf = inputSchema.allOf || []

  const allowedKeys = collectAllowedKeys(inputSchema)
  const initialParams = buildInitialParams(properties, getValue, topLevelRequired, allowedKeys)
  const canonicalParams = applyAllOf(initialParams, allOf, properties)

  const filteredCanonicalParams = Object.fromEntries(
    Object.entries(canonicalParams).filter(([key]) => allowedKeys.has(key)),
  )

  if (schema.keyToConvert) {
    schema.keyToConvert.forEach(({ from, to, values }) => {
      const value = filteredCanonicalParams[from]
      if (value === undefined || value === null) {
        return
      }

      filteredCanonicalParams[to] = values ? values[value] : value
      delete filteredCanonicalParams[from]
    })
  }

  return filteredCanonicalParams
}
